import { usePdfViewer } from 'hooks/usePdfViewer'
import React, { FC } from 'react'
import { Document, TemplateDocument } from 'types'
import { Button, Pagination } from 'react-bootstrap'

interface PDFDisplayProps {
  document: Document | TemplateDocument
}

export const downloadText = (title: string) => `(Download ${title})`
export const PDFDisplay: FC<PDFDisplayProps> = ({
  document: { title, fileUrl },
}) => {
  const { pdfDocument, setPage, page, canvasRef, triggerReload } = usePdfViewer(
    fileUrl,
  )
  const isFirstPage = page === 1
  const isLastPage = page === pdfDocument?.numPages

  const goToPrevious = () => {
    triggerReload()
    setPage(page - 1)
  }
  const goToNext = () => {
    triggerReload()
    setPage(page + 1)
  }

  return (
    <>
      <h2>{title}</h2>
      <div className="pdf-display">{<canvas ref={canvasRef} />}</div>
      <a href={fileUrl}>{downloadText(title)}</a>
      {pdfDocument?.numPages > 1 && (
        <Pagination>
          <Button disabled={isFirstPage} onClick={goToPrevious}>
            Previous
          </Button>
          <Button disabled={isLastPage} onClick={goToNext}>
            Next
          </Button>
        </Pagination>
      )}
    </>
  )
}
